module.exports = __webpack_public_path__ + "media/images/fullscreen/root_homes_keyb_black-52220ac0f665bc1d0cb6b721135eaa3a.png";